function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomBathtubFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.011 27h7.979a4.834 4.834 0 004.721-3.826H7.289A4.834 4.834 0 0012.011 27zm-.952-16.637h4.977a2.687 2.687 0 00-2.488-1.681 2.689 2.689 0 00-2.489 1.681zM28 21.174v2h-1.267C26.247 26.464 23.413 29 19.99 29h-7.979c-3.423 0-6.258-2.536-6.745-5.826H4v-2h1.184V7.682A4.688 4.688 0 019.866 3a4.688 4.688 0 014.59 3.773 4.688 4.688 0 013.773 4.59v1H8.866v-1c0-2.182 1.509-4.007 3.533-4.522A2.674 2.674 0 009.866 5a2.685 2.685 0 00-2.682 2.682v13.492H28zm-17.134-3.81h-2v-3h2v3zm1.681 0h2v-3h-2v3zm5.682 0h-2v-3h2v3z",
    fill: props.color
  }));
}

export default SvgIconRoomBathtubFilled;